/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import env from 'env'
import { withInitialLoad } from 'hocs/initialLoad'
import { coreInitialLoad } from 'redux-app/actionCreators/api'
import { getVersion } from 'api/client/actions/version'
import { isCookieAccepted } from 'redux-app/selectors/user'
import { getUserRole } from 'redux-app/selectors/auth'
import { isDataSendingToServer } from 'redux-app/selectors/forms'
import { history } from 'utils/location'
import CoreLayout from './CoreLayout'

const onPrintVersions = () => dispatch => {
  console.log(`%cFrontend version: ${__VERSION__} `, 'font-size: 16px;')
  dispatch(getVersion())
    .then(({ value: { result: { version } } }) => {
      console.log(`%cBackend version: ${version}`, 'font-size: 16px;')
    })
}

export default compose(
  connect(
    state => ({
      isCookieAccepted: isCookieAccepted(state),
      isDataSending: isDataSendingToServer(state),
      userRole: getUserRole(state),
    }),
    {
      onPrintVersions,
    },
  ),
  withRouter,
  lifecycle<any, any>({
    componentWillMount () {
      history.setHistory(this.props.history)
    },
    componentDidMount () {
      if (env.isDebugInfo) {
        this.props.onPrintVersions()
      }
    },
    componentWillReceiveProps (prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        window.scrollTo(0, 0)
      }
    },
  }),
  withInitialLoad(coreInitialLoad),
)(CoreLayout)
